import { ModalContext } from '@context/modalContext';
import {
    BaseIcon,
    cn,
    InfoOutlineIcon,
    QuestionIcon,
    RedWarningIcon,
} from '@moreharvest/component-library';
import { ButtonHTMLAttributes, ReactNode, useContext } from 'react';
import PrimaryHintModal from '../modals/PrimaryHintModal';

type icon = 'question' | 'info' | 'warning';
interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
    children: ReactNode;
    title: ReactNode;
    body: ReactNode;
    icon?: icon;
}

const buttonClasses = 'flex items-center gap-x-1 cursor-pointer';

const PrimaryHint = ({
    children,
    icon = 'question',
    title,
    body,
    className,
    onClick,
    ...props
}: Props) => {
    const { setModal } = useContext(ModalContext);
    return (
        <button
            className={cn(buttonClasses, className)}
            onClick={e => {
                onClick?.(e);
                setModal(<PrimaryHintModal title={title} body={body} />);
            }}
            {...props}
        >
            {children}
            <RenderIcon icon={icon} />
        </button>
    );
};

const RenderIcon = ({ icon }: { icon: icon }) => {
    switch (icon) {
        case 'question':
            return (
                <BaseIcon size="small">
                    <QuestionIcon className="fill-interaction-hyperlink" />
                </BaseIcon>
            );
        case 'warning':
            return (
                <BaseIcon size="small">
                    <RedWarningIcon />
                </BaseIcon>
            );
        case 'info':
        default:
            return (
                <BaseIcon size="small">
                    <InfoOutlineIcon className="fill-interaction-hyperlink" />
                </BaseIcon>
            );
    }
};

export default PrimaryHint;
